var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import './MenubarMobile.css';
import { NavBar } from '../NavBar';
import { MenubarPremise_ } from '../Attention/Premise/MenubarPremise_';
import { runtime } from '../../../classes/runtime/Runtime';
let MenubarMobile_ = class MenubarMobile_ extends React.PureComponent {
    get leftContent() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    width: 45,
                    height: 45,
                    flex: '1 1 auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                }, onClick: app.menubarUser.showMenu },
                React.createElement("i", { className: "fas fa-user" }))));
    }
    get centerContent() {
        const { app } = this.props;
        return (React.createElement("div", { onClick: app.menubar.menubarMobile.handlePathMenuClick, style: { display: 'flex' } },
            React.createElement("h1", { style: { color: '#9d9d9d', fontSize: 15, margin: 0, marginRight: 3 } }, app.solidTopic.name.substring(0, 20) + (app.solidTopic.name.length > 20 ? '...' : '')),
            ' ',
            React.createElement("i", { className: "fas fa-caret-down", style: { marginLeft: 10 } })));
    }
    get rightContent() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { fontSize: 14, display: 'flex' } },
                React.createElement(MenubarPremise_, { app: app }),
                React.createElement("div", { style: {
                        width: 45,
                        height: 45,
                        flex: '1 1 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }, onClick: app.menubar.menubarMobile.handleRightMenuClick },
                    React.createElement("i", { className: "fas fa-ellipsis-v" })))));
    }
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(NavBar, { app: app, leftContent: this.leftContent, centerContent: this.centerContent, rightContent: this.rightContent }),
            this.mobilePathDrawer,
            this.mobileUserDrawer,
            this.mobileUserDialog,
            this.rightDrawer));
    }
    get mobileUserDialog() {
        const { app } = this.props;
        if (!app.menubarUser.dialogs.isAnyUserDialogShown)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarUserDialogList } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarUserDialogList, { app: app });
    }
    get mobileUserDrawer() {
        const { app } = this.props;
        if (!app.menubar.menubarUser.isUserMenuOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarUserMenu_ } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarUserMenu_, { app: app });
    }
    get mobilePathDrawer() {
        const { app } = this.props;
        if (!app.menubar.menubarMobile.isPathDrawerOpen)
            return null;
        if (!runtime.streamedPackages.MobileLazy)
            return null;
        const { MenubarMobilePathDrawer } = runtime.streamedPackages.MobileLazy.components;
        return React.createElement(MenubarMobilePathDrawer, { app: app });
    }
    get rightDrawer() {
        const { app } = this.props;
        if (!app.menubar.menubarMobile.isRightDrawerOpen)
            return null;
        if (!runtime.streamedPackages.MobileLazy)
            return null;
        const { MenubarMobileRightDrawer } = runtime.streamedPackages.MobileLazy.components;
        return React.createElement(MenubarMobileRightDrawer, { app: app });
    }
};
MenubarMobile_ = __decorate([
    observer
], MenubarMobile_);
export { MenubarMobile_ };
